import axios from 'axios';

const DEFAULT_SPORT_BASE = 'http://localhost:8087';

/**
 * Base URL per le chiamate API sport (menu di sinistra, campionati, partite).
 *
 * In esercizio arriva da window.env (REACT_APP_API_URL), ed e' il gateway:
 * http://<server>:9001. Il valore qui sotto e' solo la rete per lo sviluppo
 * in locale.
 *
 * Nota: la 8087 NON e' il backoffice. Interrogata, si presenta come
 * ticket-service e le sue rotte sono tutte /admin/tickets e /admin/settings.
 * Il commento che diceva "usa il backoffice (8087) come proxy" era vecchio.
 */
export function getSportBaseUrl() {
  const env = typeof window !== 'undefined' ? window.env : {};
  const url =
    env.REACT_APP_SPORT_FEED_URL ||
    env.REACT_APP_BACKOFFICE_API_URL ||
    env.REACT_APP_API_URL ||
    '';
  return url || DEFAULT_SPORT_BASE;
}

/**
 * URL del feed di test statico (JSON in public), usato come fallback
 * quando l'API sport non risponde.
 */
export const SPORT_FEED_TEST_URL = '/sport-feed-test.json';

/* LE QUOTE DI UN CAMPIONATO, TENUTE DA PARTE PER POCO.
 *
 * Chi apre un campionato, torna all'elenco e lo riapre (o lo spunta e lo
 * toglie sul computer) rifaceva ogni volta la stessa chiamata: sono decine di
 * KB per campionato, e su una rete da telefono si aspettava ogni volta.
 * Per 30 secondi la risposta si riusa, e due richieste uguali partite insieme
 * ne fanno una sola. Le quote cambiano, quindi non di piu': e comunque la
 * giocata le ricontrolla sul server.
 *
 * Si restituisce sempre una COPIA: le pagine delle quote modificano gli
 * oggetti che ricevono (la scheda scelta, le partite scadute tolte), e la
 * copia tenuta qui deve restare quella arrivata dal server.
 */
const DURATA_EVENTI_MS = 30000;
const eventiTenuti = new Map();

function copia(dato) {
  if (typeof structuredClone === 'function') return structuredClone(dato);
  return JSON.parse(JSON.stringify(dato));
}

export function leggiEventiTorneo(tournamentId) {
  const chiave = String(tournamentId);
  const tenuto = eventiTenuti.get(chiave);
  if (tenuto && Date.now() - tenuto.quando < DURATA_EVENTI_MS) {
    return tenuto.promessa.then(copia);
  }
  const promessa = axios.get(
      `${getSportBaseUrl()}/private/catalog/feed/tournaments/${tournamentId}/events`,
      {timeout: 15000})
      .then((res) => (Array.isArray(res.data) ? res.data : []));
  eventiTenuti.set(chiave, {quando: Date.now(), promessa});
  // un errore non si tiene: la prossima volta si riprova
  promessa.catch(() => eventiTenuti.delete(chiave));
  return promessa.then(copia);
}

/** Solo per le prove. */
export function dimenticaEventiTorneo() {
  eventiTenuti.clear();
}
